import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=8e933624&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=8e933624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e933624",
  null
  
)

export default component.exports